/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { SelectItem } from '../../utils/types';

interface Props {
  options: SelectItem[];
  value?: SelectItem;
  placeholder: string;
  label: string;
  onChange: (value: SelectItem, keyname: string) => void;
  keyname: string;
  required?: boolean;
  size?: 'small' | 'medium';
  testid?: string;
  [key: string]: any;
}

const IntegrationReactSelect: React.FC<Props> = ({
  options,
  value,
  placeholder,
  label,
  onChange,
  keyname,
  required = false,
  size = 'medium',
  testid = 'integrationReactSelect',
  ...rest
}: Props) => {
  const handleChangeOption = (selectedOption: SelectItem) => {
    return onChange(selectedOption, keyname);
  };

  return (
    <Autocomplete
      autoFocus
      options={options}
      getOptionLabel={(option: SelectItem | string) =>
        typeof option === 'string' ? option : option.label
      }
      placeholder={label}
      value={value}
      disableClearable
      onChange={(e: React.ChangeEvent<object>, value: SelectItem) =>
        handleChangeOption(value)
      }
      id="integrationReactSelect"
      data-testid={testid}
      renderInput={(params: any) => (
        <TextField
          {...params}
          {...rest}
          autoComplete="new-password"
          label={label}
          placeholder={placeholder ?? label}
          required={required}
          size={size}
          margin="normal"
          fullWidth
        />
      )}
    />
  );
};

export default IntegrationReactSelect;
